import authService from './authService';

const BASE_URL = process.env.REACT_APP_API_URL || '';

export interface MissionAnalyticsReport {
  range: { from: string; to: string };
  totals: {
    missions: number;
    completedMissions: number;
    checkpointsTotal: number;
    checkpointsPassed: number;
    checkpointsFlagged: number;
    pointsEarned: number;
    pointsAvailable: number;
  };
  missionsByDay: { date: string; count: number }[];
  missionsByStatus: { status: string; count: number }[];
  checkpointsByStatus: { status: string; count: number }[];
  missionsBySop: { sopCode: string; sopName: string; count: number }[];
  workerActivity: {
    workerId: string;
    workerName: string;
    missionCount: number;
    completedMissions: number;
    avgCheckpointCompletionPct: number;
  }[];
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatYmd(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function defaultMissionReportRange(): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - 30);
  return { from: formatYmd(from), to: formatYmd(to) };
}

/**
 * GET /api/missions/reports/summary — supervisor-only; same mission engine as the mobile app.
 */
export async function fetchMissionAnalyticsReport(
  from: string,
  to: string,
): Promise<{ ok: true; data: MissionAnalyticsReport } | { ok: false; status: number; message: string }> {
  const q = new URLSearchParams({ from, to });
  const url = `${BASE_URL.replace(/\/$/, '')}/api/missions/reports/summary?${q.toString()}`;
  const res = await authService.apiCall(url, { method: 'GET' });
  const body = await res.json().catch(() => ({}));
  if (res.status === 403) {
    return { ok: false, status: 403, message: body?.message || 'Forbidden' };
  }
  if (!res.ok || !body?.success) {
    return {
      ok: false,
      status: res.status,
      message: body?.message || `Request failed (${res.status})`,
    };
  }
  return { ok: true, data: body.data as MissionAnalyticsReport };
}
